



















































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  school_id : number,
  student: any
  errors: any[],
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      school_id : context.root.$store.state.currentUser.school_id,
      student: {
        email: "",
        email_new: "",
        email_confirmation: "",
      },
      errors: [],
    });

    // 更新ボタン押下
    const updateClick = async () => {

      if(!validate() || !window.confirm("メールアドレスを更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/student/account/update_email`, {student: state.student}).then(response => {
        alert("メールアドレスの更新が完了しました。");
        context.root.$router.push(`/${state.school_id}/student_site/sheet_list`).catch(err => {});
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    // バリデーション
    const validate = () => {

      state.errors = [];

      var regex = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
      if (!regex.test(state.student.email_new)) {
        state.errors.push("新しいメールアドレスのフォーマットを確認してください。");
      }

      if (state.student.email_new != state.student.email_confirmation) {
        state.errors.push("新しいメールアドレス欄と再入力欄の入力内容が異なります。");
      }

      return state.errors.length == 0;
    }

    const to = (page: string) => {
      context.root.$router.push(page).catch(err => {});
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      // ユーザー情報をapiから取得
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/student/account?id=${context.root.$store.state.currentUser.id}`).then(response => {
        var user = response.data.user;
        state.student.email = user.email;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`ユーザー情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`ユーザー情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        context.root.$router.push(`/${state.school_id}/student_site/sheet_list`).catch(err => {});
      });
      context.root.$store.dispatch("hideOverlay");
    })

    return {
      ...toRefs(state),
      updateClick,
      to,
    }
  }
})
